<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-main>
    <v-container fluid fill-height>
      <v-layout wrap justify-center align-center class="text-sm-left view-dynamic-container" v-resize="recalculateSize">
        <v-card width="100%">
          <v-card-title>
            <span>Ratenkalender&nbsp;</span>
            <span v-if="selected !== undefined && stepper === 2"> für {{selected.name}}</span>
            <v-spacer></v-spacer>
            <v-btn @click="fetchRatesPlans()"
                   v-if="selected !== undefined && stepper === 2"
                   style="margin: -5px 0 0;" color="primary">Raten aktualisieren</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding: 0;">
            <v-layout wrap>
              <v-flex xs12>
                <v-stepper v-model="stepper">
                  <v-stepper-header class="teal lighten-5">
                    <v-stepper-step :editable="stepper > 1" :complete="stepper > 1" step="1">
                      {{ $t('hotel.edit.select') }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 2" :editable="stepper > 2" step="2">
                      Ratenkalender anzeigen
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card color="white" style="position: relative;">
                        <v-data-table
                          :headers="headers"
                          :items="hotels"
                          :page.sync="pagination"
                          :items-per-page.sync="itemsPerPage"
                          :server-items-length="total"
                          :footer-props="{itemsPerPageOptions: [10, 25, 50, 75, 100]}"
                          :loading="loading">
                          <template v-slot:item="props">
                            <tr>
                              <td>
                                <v-layout wrap>
                                  <v-flex xs12 pt-3>
                                    <h2>{{ props.item.name }}</h2>
                                    <p>{{ props.item.channel }}</p>
                                  </v-flex>
                                </v-layout>
                              </td>
                              <td class="text-sm-right">
                                <v-btn outlined color="primary" style="margin: 0;" @click="selectHotel(props.item)">
                                  {{ $t('hotel.create.select') }}
                                </v-btn>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-stepper-content>


                    <v-stepper-content step="2">
                      <v-layout wrap v-if="selected !== undefined">
                        <v-container grid-list-xl style="padding: 4px;">
                          <v-layout wrap>
                            <v-flex xs6 sm4 md2 lg2 xl2>
                              <v-menu :close-on-content-click="false"
                                      v-model="datepicker.menu"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="formatReadableDate"
                                    label="Ab Datum"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="datepicker.date" no-title
                                               first-day-of-week="1" locale="de"
                                               scrollable @input="datepicker.menu = false"></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs6 sm4 md2 lg2 xl2>
                              <v-select
                                v-model="day"
                                :items="days"
                                label="Tage anzeigen"
                              ></v-select>
                            </v-flex>
                            <v-flex sm4 md3 lg3 xl2>
                              <v-select
                                v-model="availability"
                                :items="availabilities"
                                item-text="label"
                                item-value="value"
                                label="Verfügbarkeit"
                              ></v-select>
                            </v-flex>
                            <v-flex sm4 md3 lg3 xl2>
                              <v-select
                                v-model="filter.selected"
                                :items="filter.rooms"
                                item-text="label"
                                item-value="value"
                                label="Zimmer anzeigen"
                              ></v-select>
                            </v-flex>
                            <v-flex sm8 md2 lg2 xl4 class="text-xs-right" pt-1 pb-3>
                              <v-btn outlined color="primary" @click="nextDays()" style="margin-top: 17px;">
                                Nächste {{day}} Tage
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-container>
                        <v-flex xs12 class="calendar" v-show="!dialog">
                          <div class="left-calendar">
                            <div class="calendar-container">
                              <div class="calendar-row-container" v-for="(room, roomIndex) in getRooms()" :key="room.id" v-if="!room.ignore">
                                <div class="name-container">
                                  <div class="rate-date-empty-room" v-if="roomIndex === 0"></div>
                                  <div class="rate-date-small-empty" v-else></div>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-chip @click="openRoomDialog(room)" v-on="on">{{room.name}}</v-chip>
                                    </template>
                                    <span>Zimmercode: {{room.externalId}}</span>
                                  </v-tooltip>
                                </div>
                                <div class="rate-container">
                                  <div class="rate-name-container">
                                    <div class="rate-date-empty" v-if="roomIndex === 0"></div>
                                    <div :class="getRatePlanEmptyClass(room)" v-else></div>
                                    <template v-for="(rate, index) in getRatePlans(room)">
                                      <div class="rate-name" :key="'day_name_index_'+index">
                                        <v-card @click="openRateDialog(rate)">
                                          <v-card-text>
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <span v-on="on">{{rate.name}}</span>
                                              </template>
                                              <span>Ratencode: {{rate.ratePlan}}</span>
                                            </v-tooltip>
                                          </v-card-text>
                                        </v-card>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="right-calendar" id="right-calendar" v-show="!dialog">
                            <div class="calendar-container">
                              <div class="rate-container" v-for="(room, roomIndex) in getRooms()" :key="room.id" v-if="!room.ignore">
                                <div class="rate-days-container" v-if="rateIndex === 0" v-for="(rate, rateIndex) in getRatePlans(room)" :key="'date_'+rate.id" :style="getHeight(roomIndex, rateIndex)">
                                  <template v-for="day in getDays(rate)">
                                    <v-card :key="'date_'+day.id" class="rate-date-container-color">
                                      <v-card-text>
                                        <div class="rate-date">
                                          <div v-if="roomIndex === 0">
                                            <div class="day-string">
                                              {{day.from | day}}
                                            </div>
                                            <div class="day-month">
                                              {{day.from | dayMonth}}
                                            </div>
                                            <div class="day-year">
                                              {{day.from | year}}
                                            </div>
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <div class="occupancy-rate" v-on="on">
                                                  {{day.occupancyRate}} %
                                                </div>
                                              </template>
                                              <span>Hotel Auslastung</span>
                                            </v-tooltip>
                                            <v-icon class="minimum-stay-notification" color="primary" v-if="hasEvent(day)" @click="openEventDialog(day, rate)">event</v-icon>
                                          </div>
                                          <div class="rate-availability" :style="calculateColor(day, room)" v-if="availability === 'OCCUPANCY'">
                                            <span>{{ day.availableRooms }}</span>
                                          </div>
                                          <div class="rate-availability" :style="calculateColor(day, room)" v-else>
                                              <span>{{ day.roomOccupancyRate }}</span> <span v-if="day.roomOccupancyRate !== '-'"> %</span>
                                          </div>
                                        </div>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </div>
                                <div class="rate-days-container" v-for="rate in getRatePlans(room)" :key="rate.id" :style="setTableCellHeight(width)">
                                  <template v-for="day in getDays(rate)">
                                    <v-card :key="day.id">
                                      <v-card-text>
                                        <div :class="['rate-content']">
                                          <span>{{day.price | price}} €</span>
                                          <v-icon :class="['surcharge', {edited: day.surcharge}]" v-if="day.surchargeType !== 'FORBIDDEN'" @click="openSurcharge(day, rate, room)">add_box</v-icon>
                                          <v-icon class="minimum-stay-notification" color="primary" v-if="isKognitivHotel() && hasMinStay(day)" @click="openEventDialog(day, rate)">local_hotel</v-icon>
                                        </div>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-dialog
          v-model="dialog"
          hide-overlay
          persistent
          width="300">
          <v-card
            color="primary"
            dark>
            <v-card-text>
              Raten werden geladen
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="event.dialog" scrollable :fullscreen="isSmall()" max-width="800px">
          <v-card v-if="event.dialog">
            <v-card-title>
              <h3 style="margin-bottom: 30px;">Kalender von {{ event.day.from | dayFull }} den {{ event.day.from | date }}</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <v-layout wrap mt-1>
                <v-flex xs12 v-if="isKognitivHotel() && hasMinStay(event.day)" mb-2>
                  <h2>Mindestaufenthalt</h2>
                </v-flex>
                <v-flex xs12 v-if="isKognitivHotel() && hasMinStay(event.day)" v-for="minStay in getMinStays()" :key="minStay.id">
                  <v-layout wrap pt-1 pb-1>
                    <v-flex xs4 sm4>
                      <h4>Gültig bis</h4>
                      {{ minStay.validUntil | date }}
                    </v-flex>
                    <v-flex xs4 sm4>
                      <h4>Von</h4>
                      {{ minStay.blockedFrom | date }}
                    </v-flex>
                    <v-flex xs4 sm4>
                      <h4>Bis</h4>
                      {{ minStay.blockedTo | date }}
                    </v-flex>
                    <v-flex xs6 sm4>
                      <h4>Anreise</h4>
                      {{ getCategoryLabel(minStay.arrival) }}
                    </v-flex>
                    <v-flex xs6 sm4>
                      <h4>Abreise</h4>
                      {{ getCategoryLabel(minStay.departure) }}
                    </v-flex>
                    <v-flex xs12 sm4 class="minimum-stay-container">
                      <h4>Mindestaufenthalt</h4>
                      {{ getMinOccupancyNights(minStay.rules, event.day) }}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-if="hasEvent(event.day)" mb-2>
                  <h2>Events</h2>
                </v-flex>
                <v-flex xs12 v-if="hasEvent(event.day)" v-for="(hotelEvent, index) in getEvents()" :key="hotelEvent.id">
                  <v-layout wrap pt-1 pb-1>
                    <v-flex xs12 sm5>
                      <h4>Titel</h4>
                      {{ hotelEvent.name }}
                    </v-flex>
                    <v-flex xs4 sm2>
                      <h4>Aufschlag</h4>
                      {{ hotelEvent.percent }} %
                    </v-flex>
                    <v-flex xs4 sm3>
                      <h4>Region</h4>
                      <span v-if="hasLand(hotelEvent.region)">{{ $t('land.' + hotelEvent.region) }}</span>
                      <span v-else>{{ hotelEvent.region }}</span>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <h4>Kategorie</h4>
                      {{ $t('event.' + hotelEvent.category) }}
                    </v-flex>
                    <v-flex xs12 mt-1>
                      <h4>Kommentar</h4>
                      <div v-html="hotelEvent.comment"></div>
                    </v-flex>
                  </v-layout>
                  <v-divider v-if="index < (getEvents().length - 1)"></v-divider>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="event.dialog = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog content-class="dynamic-price-calendar-rate-container" scrollable v-model="rate.dialog" max-width="500px">
          <v-card v-if="rate.dialog">
            <v-card-title>
              <h3 style="margin-bottom: 30px;">Rate</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <v-layout wrap row mt-1 v-if="rate.value !== undefined">
                <v-flex xs12>
                  <h3>Preisgestaltung nach Belegung</h3>
                </v-flex>
                <v-flex xs12 v-if="rate.value.paymentType === 'FULLPRICE'">
                  {{ this.$i18n.t('hotel.kognitiv.fullPrice') }}
                </v-flex>
                <v-flex xs12 v-else>
                  {{ this.$i18n.t('hotel.kognitiv.custom') }}
                </v-flex>
                <v-flex xs12 v-if="rate.value.paymentType === 'CUSTOM'">
                  Es wird {{ rate.value.payment / 100 }} <span v-if="rate.value.paymentMode === 'PERCENT'"> %</span> <span v-else> €</span> von Vollpreis abgezogen.
                </v-flex>
                <v-flex xs12 mt-2>
                  <h3>Zusatzgäste</h3>
                </v-flex>
                <v-flex xs12>
                  {{ rate.value.additionalGuestPrice | price }} €
                </v-flex>
                <v-flex xs12 mt-2 v-if="rate.value.childrenRules !== undefined && rate.value.childrenRules.length > 0">
                  <h3>Regelung für die Kinder</h3>
                </v-flex>
                <v-flex xs12 v-if="rate.value.childrenRules !== undefined && rate.value.childrenRules.length > 0">
                  <v-list dense>
                    <div v-for="(rule, index) in rate.value.childrenRules" :key="index">
                      <div style="margin-top: 5px; margin-bottom: 5px;">
                        <v-list-tile>
                          <v-list-tile-content>Kinder bis Alter von</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ rule.age }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>{{ $t('hotel.kognitiv.additionalGuestPrice') }}</v-list-tile-content>
                          <v-list-tile-content class="align-end">
                            {{ rule.price | price }} €
                          </v-list-tile-content>
                        </v-list-tile>
                      </div>
                      <v-divider v-if="index < (rate.value.childrenRules.length - 1)"></v-divider>
                    </div>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="rate.dialog = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="room.dialog" max-width="800px">
          <v-card v-if="room.dialog">
            <v-card-title>
              <h3 style="margin-bottom: 30px">Zimmer Raten-Matrix</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <v-layout wrap row>
                <v-flex xs1>
                  <h3 style="transform: rotate(-90deg); text-align: center;margin-top: 150px;">Auslastung</h3>
                </v-flex>
                <v-flex xs11>
                  <table class="rate-matrix-table" border="0" cellspacing="0" cellpadding="0">
                    <tbody>
                    <tr v-for="roomRate in room.rates" :key="'occupancy'+roomRate.occupancyRate">
                      <td>
                        <v-btn depressed small color="white">
                          <h3>{{ roomRate.occupancyRate }}</h3>
                        </v-btn>
                      </td>
                      <td v-for="(rate, index) in roomRate.rateMatrix" :key="index">
                        <v-btn depressed small :class="[setColor(rate, room.value)]">
                              <span v-if="rate.percent === undefined">
                                N/A
                              </span>
                          <span v-else>
                                {{ rate.percent }}%
                              </span>
                        </v-btn>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot v-if="isCityHotel()">
                    <tr>
                      <td></td>
                      <td v-for="rangeSpan in cityRangeSpan" :key="rangeSpan">
                        <h3 v-if="rangeSpan < 30">{{rangeSpan}}</h3>
                        <h3 v-else>{{rangeSpan}}+</h3>
                      </td>
                    </tr>
                    </tfoot>
                    <tfoot v-else>
                    <tr>
                      <td></td>
                      <td v-for="rangeSpan in holidayRangeSpan" :key="rangeSpan">
                        <h3>{{rangeSpan}}</h3>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </v-flex>
                <v-flex xs10 offset-xs2 mt-2>
                  <h3 class="text-sm-center">Tage bis zu Ankunft</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="room.dialog = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="charge.dialog" persistent max-width="800px">
          <v-card v-if="charge.dialog">
            <v-card-title>
              <h3 style="margin-bottom: 30px; text-align: left;">Preismodifikation verwalten</h3>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <v-layout wrap>
                <v-flex xs4 sm4 md2>
                  <h3>Datum</h3>
                  <p>{{charge.day.from | date}}</p>
                </v-flex>
                <v-flex xs4 sm4 md5>
                  <h3>Zimmer</h3>
                  <p>{{charge.room.name}}</p>
                </v-flex>
                <v-flex xs4 sm4 md5>
                  <h3>Rate</h3>
                  <p>{{ charge.rate.name }}</p>
                </v-flex>
                <v-flex xs12 class="text-sm-center">
                  <h3 class="text-xs-center mb-2">Berechnungsart</h3>
                  <v-btn color="primary" class="dynamic-surcharge-btn" style="font-size: 18px;"
                         :outlined="charge.day.surchargeType !== 'PERCENT'"
                         @click="selectPercent()">%</v-btn>
                  <v-btn color="primary" class="dynamic-surcharge-btn" style="font-size: 18px;"
                         :outlined="charge.day.surchargeType !== 'EURO'"
                         @click="selectEuro()">€</v-btn>
                </v-flex>
                <v-flex xs12 class="text-sm-center">
                  <h2 class="text-sm-center mb-2 mt-4">Wert</h2>
                  <div class="dynamic-surcharge-value-container">
                    <span class="surcharge-value"
                          v-text="charge.day.surchargeValue"></span>
                    <span v-if="charge.day.surchargeType === 'PERCENT'"> %</span>
                    <span v-if="charge.day.surchargeType === 'EURO'"> €</span>
                  </div>
                  <v-slider
                    v-model="charge.day.surchargeValue"
                    always-dirty
                    color="primary"
                    min="-100"
                    max="100">
                    <v-icon
                      slot="prepend"
                      color="primary"
                      @click="decrementSurcharge()">
                      remove
                    </v-icon>

                    <v-icon
                      slot="append"
                      color="primary"
                      @click="incrementSurcharge()">
                      add
                    </v-icon>
                  </v-slider>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="charge.dialog = false">{{ $t('close') }}</v-btn>
              <v-btn color="primary" outlined @click.native="removeSurcharge()">Änderungen entfernen</v-btn>
              <v-btn color="primary" @click.native="saveSurcharge()">Änderungen speichern</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
    <v-snackbar
      :color="snackbar.result"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="snackbar.value = false">
        {{$t("close")}}
      </v-btn>
    </v-snackbar>
  </v-main>
</template>

<script>
  import DynamicPriceUtil from '../../mixins/DynamicPriceUtil';
  export default {
    name: 'DynamicPriceAdmin',
    mixins: [DynamicPriceUtil],
    data() {
      return {
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        stepper: 1,
        selected: undefined,
        hotels: [],
        loading: false,
        total: 0,
        itemsPerPage: 10,
        pagination: undefined,
        headers: [
          { text: this.$i18n.t('hotel.create.hotelName'),
            sortable: false, value: 'name' },
          { text: this.$i18n.t('manageYieldStaff.actions'),
            sortable: false, align: 'right' }
        ],
        datepicker: {
          date: this.$moment().format('YYYY-MM-DD'),
          menu: false
        },
        days: [7, 14, 30],
        day: 7,
        availabilities: [
          { value: 'OCCUPANCY', label: 'Verfügbare Zimmer' },
          { value: 'OCCUPANCY_RATE', label: 'Auslastung' }
        ],
        availability: 'OCCUPANCY',
        dialog: false,
        rate: {
          dialog: false,
          value: undefined
        },
        room: {
          dialog: false,
          value: undefined,
          rates: []
        },
        occupancyRates: [100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0],
        cityRangeSpan: ['0', '1', '2', '3', '4', '5', '30', '60', '90', '180'],
        holidayRangeSpan: ['0', '1', '2', '3', '4', '30', '60', '90', '180'],
        event: {
          day: undefined,
          rate: undefined,
          dialog: false
        },
        width: undefined,
        charge: {
          dialog: false,
          loading: false,
          day: {
            surchargeType: undefined,
            surchargeValue: 0,
            surcharge: false,
          },
          rate: undefined,
          room: undefined
        },
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        filter: {
          selected: 'ALL',
          rooms: []
        }
      };
    },
    watch: {
      pagination: {
        handler (pagination) {
          this.fetchData(pagination - 1);
        }
      },
      itemsPerPage: {
        handler (itemsPerPage) {
          this.itemsPerPage = itemsPerPage;
          this.fetchData(this.pagination - 1);
        }
      }
    },
    mounted() {
      this.pagination = 1;
      this.recalculateSize();
    },
    methods: {
      recalculateSize() {
        this.width = (window.innerWidth || document.documentElement.clientWidth
          || document.body.clientWidth);
      },
      isSmall() {
        return this.width < 960;
      },
      fetchData(pagination) {
        this.loading = true;
        this.$http.get('hotels/pagination?size='.concat(this.itemsPerPage)
          .concat('&page=').concat(pagination)).then((body) => {
          this.hotels = body.data.content;
          this.total = body.data.totalElements;
          this.loading = false;
        });
      },
      isKognitivHotel() {
        return this.selected.channel === 'KOGNITIV';
      },
      fetchRatesPlans() {
        this.dialog = true;
        this.$http.get('dynamic/'
          .concat(this.selected.id)).then((data) => {
          if (this.isKognitivHotel()) {
            for (let i = 0; i < this.selected.kognitivHotelRooms.length; i += 1) {
              const room = this.selected.kognitivHotelRooms[i];
              if (!room.ignore) {
                this.filter.rooms.push({label: room.name, value: room.externalId});
              }
              for (let j = 0; j < room.kognitivRatePlans.length; j += 1) {
                const ratePlan = room.kognitivRatePlans[j];
                ratePlan.minStays.sort((a, b) => {
                  return new Date(a.validUntil) - new Date(b.validUntil);
                });
                for (let k = 0; k < data.body.length; k += 1) {
                  const dynamicRatePlan = data.body[k];
                  if (ratePlan.ratePlan === dynamicRatePlan.ratePlanCode) {
                    ratePlan.dynamicDays = dynamicRatePlan.dynamicDays.sort((a, b) => {
                      return new Date(a.from) - new Date(b.from);
                    });
                    break;
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < this.selected.casablancaHotelRooms.length; i += 1) {
              const room = this.selected.casablancaHotelRooms[i];
              if (!room.ignore) {
                this.filter.rooms.push({label: room.name, value: room.externalId});
              }
              const check = this.hasDynamicRoom(room.externalId, data.body);
              if (check.hasRoom) {
                room.ratePlans = [{
                  id: 'tourSol_'.concat(room.roomCode),
                  name: 'TourSol',
                  ratePlan: 'TourSol',
                  dynamicDays: check.dynamicRoom.dynamicDays.sort((a, b) => {
                    return new Date(a.from) - new Date(b.from);
                  })
                }];
              } else {
                room.ratePlans = [{
                  id: 'tourSol_'.concat(room.roomCode),
                  name: 'TourSol',
                  ratePlan: 'TourSol',
                  dynamicDays: [{
                    id: 'empty-day-'.concat(i),
                    from: this.$moment().format('YYYY-MM-DD'),
                    price: 0,
                    singlePrice: 0,
                    occupancyRate: 0,
                    roomOccupancyRate: '-',
                    eventPercent: 0,
                    availableRooms: '-',
                    availableGlobalRooms: 0,
                    surcharge: false,
                    minimumStay: '',
                    arrival: '',
                    departure: '',
                    surchargeType: 'FORBIDDEN'
                  }]
                }];
              }
            }
          }
          if (document.getElementById('right-calendar') !== undefined
            && document.getElementById('right-calendar').addEventListener) {
            // IE9, Chrome, Safari, Opera
            document.getElementById('right-calendar').addEventListener('mousewheel', this.scrollHorizontally, false);
            // Firefox
            document.getElementById('right-calendar').addEventListener('DOMMouseScroll', this.scrollHorizontally, false);
          } else {
            // IE 6/7/8
            document.getElementById('right-calendar').attachEvent('onmousewheel', this.scrollHorizontally);
          }
          this.dialog = false;
        });
      },
      hasDynamicRoom(externalId, dynamicRooms) {
        const check = {
          hasRoom: false,
          dynamicRoom: undefined
        };

        for (let j = 0; j < dynamicRooms.length; j += 1) {
          const dynamicRoom = dynamicRooms[j];
          if (externalId === dynamicRoom.roomCode) {
            check.hasRoom = true;
            check.dynamicRoom = dynamicRoom;
            break;
          }
        }
        return check;
      },
      selectHotel(hotel) {
        this.filter.selected = 'ALL';
        this.filter.rooms = [{label: 'Alle', value: 'ALL'}];
        if (hotel.channel === 'KOGNITIV') {
          hotel.kognitivHotelRooms.sort(function(a, b){return a.position - b.position});
          for (let i = 0; i< hotel.kognitivHotelRooms.length; i += 1) {
            const room = hotel.kognitivHotelRooms[i];
            room.kognitivRatePlans.sort(function(a, b){return a.position - b.position});
          }
        } else {
          hotel.casablancaHotelRooms.sort(function(a, b){return a.position - b.position});
        }
        this.selected = hotel;
        this.fetchRatesPlans();
        this.stepper = 2;
      },
      getDays(rate) {
        const days = [];
        if (rate.dynamicDays !== undefined) {
          for (let i = 0; i < this.day; i += 1) {
            const date = this.$moment(this.datepicker.date).add(i, 'days');
            let hasDate = false;
            for (let j = 0; j < rate.dynamicDays.length; j += 1) {
              const dynamicDay = rate.dynamicDays[j];
              if (date.format('YYYY-MM-DD') === dynamicDay.from) {
                days.push(dynamicDay);
                hasDate = true;
                break;
              }
            }
            if (!hasDate) {
              days.push({
                id: 'empty-day-'.concat(i),
                from: date.format('YYYY-MM-DD'),
                price: 0,
                singlePrice: 0,
                occupancyRate: 0,
                roomOccupancyRate: '-',
                eventPercent: 0,
                availableRooms: '-',
                availableGlobalRooms: 0,
                surcharge: false,
                minimumStay: '',
                arrival: '',
                departure: '',
                surchargeType: 'FORBIDDEN'
              });
            }
          }
        }
        return days;
      },
      nextDays() {
        this.datepicker.date = this.$moment(this.datepicker.date)
          .add(this.day, 'days').format('YYYY-MM-DD');
      },
      openSurcharge(day, rate, room) {
        this.charge.day = day;
        this.readableSurchargeCategory();
        this.charge.rate = rate;
        this.charge.room = room;
        this.charge.dialog = true;
      },
      readableSurchargeCategory() {
        if (!this.hasSurchargeType()) {
          this.charge.day.surchargeType = 'PERCENT';
          this.charge.day.surchargeValue = 0;
          this.charge.day.surcharge = false;
        }
      },
      hasSurchargeType() {
        return this.charge.day.surchargeType !== undefined
          && this.charge.day.surchargeType !== null;
      },
      decrementSurcharge() {
        this.charge.day.surchargeValue -= 1;
      },
      incrementSurcharge() {
        this.charge.day.surchargeValue += 1;
      },
      selectPercent() {
        this.charge.day.surchargeType = 'PERCENT';
      },
      selectEuro() {
        this.charge.day.surchargeType = 'EURO';
      },
      removeSurcharge() {
        this.charge.loading = true;
        this.charge.day.surchargeValue = 0;
        if (this.isKognitivHotel()) {
          this.$http.put('dynamic/day', this.charge.day).then(() => {
            this.charge.day.surcharge = false;
            this.snackbar.result = 'success';
            this.snackbar.text = 'Aufschlag wurde entfernt. Aktualisierung kann bis zu 2 Minuten dauern.';
            this.snackbar.value = true;
            this.charge.loading = false;
            this.charge.dialog = false;
          }, () => {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
            this.snackbar.value = true;
            this.charge.loading = false;
          });
        } else {
          this.$http.put('dynamic/day/'.concat(this.selected.externalId), this.charge.day).then((data) => {
            let index = -1;
            for (let i = 0; i < this.charge.rate.dynamicDays.length; i += 1) {
              if (this.charge.rate.dynamicDays[i].id === this.charge.day.id) {
                index = i;
                break;
              }
            }
            if (index !== -1) {
              this.$set(this.charge.rate.dynamicDays, index, data.body);
            }
            this.snackbar.result = 'success';
            this.snackbar.text = 'Aufschlag wurde entfernt.';
            this.snackbar.value = true;
            this.charge.loading = false;
            this.charge.dialog = false;
          }, () => {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
            this.snackbar.value = true;
            this.charge.loading = false;
          });
        }
      },
      saveSurcharge() {
        this.charge.loading = true;
        if (this.isKognitivHotel()) {
          this.$http.put('dynamic/day', this.charge.day).then(() => {
            this.charge.day.surcharge = true;
            this.snackbar.result = 'success';
            this.snackbar.text = 'Aufschlag wurde gespeichert. Aktualisierung kann bis zu 2 Minuten dauern.';
            this.snackbar.value = true;
            this.charge.loading = false;
            this.charge.dialog = false;
          }, () => {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
            this.snackbar.value = true;
            this.charge.loading = false;
          });
        } else {
          this.$http.put('dynamic/day/'.concat(this.selected.externalId), this.charge.day).then((data) => {
            let index = -1;
            for (let i = 0; i < this.charge.rate.dynamicDays.length; i += 1) {
              if (this.charge.rate.dynamicDays[i].id === this.charge.day.id) {
                index = i;
                break;
              }
            }
            if (index !== -1) {
              this.$set(this.charge.rate.dynamicDays, index, data.body);
            }
            this.snackbar.result = 'success';
            this.snackbar.text = 'Aufschlag wurde gespeichert.';
            this.snackbar.value = true;
            this.charge.loading = false;
            this.charge.dialog = false;
          }, () => {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
            this.snackbar.value = true;
            this.charge.loading = false;
          });
        }
      },
      showSurcharge(day) {
        let show = false;
        if (this.sevenDays !== undefined
          && this.$moment(day.from).isBefore(this.sevenDays)) {
          show = true;
        }
        return show;
      },
      openRateDialog(rate) {
        if (this.room.maxOccupancy > 1) {
          this.rate.value = rate;
          this.rate.dialog = true;
        }
      },
      openRoomDialog(room) {
        room.rates = room.rates.sort((a, b) => {
          return a.percent - b.percent;
        });
        this.room.value = room;
        this.room.rates = [];
        for (let i = 0; i < this.occupancyRates.length; i += 1) {
          const occupancyRate = this.occupancyRates[i];
          this.room.rates.push({
            occupancyRate: occupancyRate,
            rateMatrix: this.getRatesFor(occupancyRate, room)
          });
        }
        this.room.dialog = true;
      },
      getHeight(roomIndex, rateIndex) {
        let style = '';
        if (roomIndex === 0 && rateIndex === 0) {
          if (this.width <= 960) {
            style = 'height: 126px;';
          } else {
            style = 'height: 140px;';
          }
        }

        if (roomIndex !== 0) {
          style = 'margin-top: 5px;';
          if (this.width <= 960) {
            style = style.concat('height: 35px;');
          } else {
            style = style.concat('height: 40px;');
          }
        }

        return style;
      },
      isCityHotel() {
        return this.selected === undefined ? false : this.selected.hotelType === 'CITYHOTEL';
      },
      openEventDialog(day, rate) {
        this.event.day = day;
        this.event.rate = rate;
        this.event.dialog = true;
      },
      getMinStays() {
        const minStays = [];
        if (this.isKognitivHotel()) {
          const day = this.$moment(this.event.day.from);
          for (let i = 0; i < this.event.rate.minStays.length; i += 1) {
            const minStay = this.event.rate.minStays[i];
            const blockedFrom = this.$moment(minStay.blockedFrom);
            const blockedTo = this.$moment(minStay.blockedTo);
            if (blockedFrom.isSameOrBefore(day) && blockedTo.isSameOrAfter(day)) {
              minStays.push(minStay);
            }
          }
          minStays.push(...this.addGlobalMinStay(day));
        }
        return minStays;
      },
      addGlobalMinStay(day) {
        const minStays = [];
        for (let i = 0; i < this.selected.minStays.length; i += 1) {
          const minStay = this.selected.minStays[i];
          const blockedFrom = this.$moment(minStay.blockedFrom);
          const blockedTo = this.$moment(minStay.blockedTo);
          if (blockedFrom.isSameOrBefore(day) && blockedTo.isSameOrAfter(day)) {
            minStays.push(minStay);
          }
        }
        return minStays;
      },
      getEvents() {
        const events = [];
        const day = this.$moment(this.event.day.from);
        for (let i = 0; i < this.selected.events.length; i += 1) {
          const event = this.selected.events[i];
          const eventFrom = this.$moment(event.from);
          const eventTo = this.$moment(event.to);
          if (eventFrom.isSame(day) || eventTo.isSame(day)) {
            events.push(event);
          } else if (day.isBetween(eventFrom, eventTo)) {
            events.push(event);
          }
        }
        return events;
      },
      filterRooms(hotelRooms) {
        if (this.filter.selected === 'ALL') {
          return hotelRooms;
        } else {
          const filtered = [];
          for (let i = 0; i < hotelRooms.length; i += 1) {
            const room = hotelRooms[i];
            if (room.externalId === this.filter.selected) {
              filtered.push(room);
              break;
            }
          }
          return filtered;
        }
      },
      getRooms() {
        if (this.isKognitivHotel()) {
          return this.filterRooms(this.selected.kognitivHotelRooms);
        } else {
          return this.filterRooms(this.selected.casablancaHotelRooms);
        }
      },
      getRatePlans(room) {
        if (this.isKognitivHotel()) {
          return room.kognitivRatePlans;
        } else {
          return room.ratePlans;
        }
      },
      getRatePlanEmptyClass(room) {
        if (this.getRatePlans(room) === undefined
          || this.getRatePlans(room) === null) {
          return 'rate-date-small-empty';
        }
        return this.getRatePlans(room).length > 1 ? 'rate-date-small-empty' : 'single-rate-date-small-empty';
      },
    },
    computed: {
      formatReadableDate() {
        return this.$moment(this.datepicker.date).format('DD.MM.YYYY');
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/dynamic";
</style>


